import { FC } from "react"

interface SelectedMediaDeviceItemProps{
    mediaDevice: MediaDeviceInfo
    removeDevice: (device: MediaDeviceInfo) => void
}

/**
 * @abstract This component handles each mediaDevices added as extra to publish track
 */
const SelectedDevicesItem: FC<SelectedMediaDeviceItemProps>= (props) => {
    const { mediaDevice, removeDevice } = props

    const handleRemove = () => {
        removeDevice(mediaDevice)
    }

    return(
        <div className="SelectedMediaDevices__Item">
            <p className="SelectedMediaDevice__Name">
                {mediaDevice.label}
            </p>
            <i className="far fa-times" onClick={handleRemove}/>   
        </div>
    )
}

export default SelectedDevicesItem